import React, { useState } from "react";
import "./style.css";
import ShippingPolicy from "./ShippingPolicy.jsx";

const Index = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div>
      <div
        onClick={handleShowModal}
        className="hover:text-blue-500 text-base mt-6 text-black cursor-pointer"
      >
        Shipping Policy
      </div>

      {showModal && (
        <div className="modal-overlay">
          <ShippingPolicy handleCloseModal={handleCloseModal} />
        </div>
      )}
    </div>
  );
};

export default Index;
